import { createSlice } from '@reduxjs/toolkit';
import type { AccountState } from './types';

const slice = createSlice({
  name: 'account',
  initialState: {} as AccountState,
  reducers: {
    setLoadingMe: (state, action) => {
      state.loadingMe = action.payload;
    },
    /**
     * Set when the bootstrap failed for a reason that is not a bad session.
     *
     * Takes the reason, not just a flag. An invisible failure is the thing this whole area kept
     * producing - a redirect loop nobody could read - so whatever went wrong is carried through to
     * the screen, where the person can repeat it to support.
     */
    setMeError: (state, action) => {
      state.meError = !!action.payload;
      state.meErrorDetail = typeof action.payload === 'string' ? action.payload : undefined;
    },
    setMe: (state, action) => {
      state.me = action.payload;
      state.loadingMe = false;
      state.meError = false;
      state.meErrorDetail = undefined;
    },
    setAccounts: (state, action) => {
      state.accounts = action.payload;
    },
    setCurrentAccount: (state, action) => {
      state.currentAccount = action.payload;
    },
    setCurrentFullAccount: (state, action) => {
      state.currentFullAccount = action.payload;
    },
    setCurrentAccountWithUsers: (state, action) => {
      state.currentAccountWithUsers = action.payload;
    },
    setAccountWithUsers: (state, action) => {
      state.accountWithUsers = action.payload;
      state.accountWithUsersError = undefined;
    },
    setAccountWithUsersError: (state, action) => {
      state.accountWithUsersError = action.payload || 'unavailable';
    },
    setProjectScopedRefused: (state, action) => {
      state.projectScopedRefusedAccountId = action.payload;
    },
    setOffices: (state, action) => {
      state.offices = action.payload;
      if (!state.offices?.length) state.currentOffice = undefined;
      else if (state.currentOffice?.id) {
        const current = state.offices.find((o) => o.id === state.currentOffice?.id);
        state.currentOffice = current ?? state.offices[0];
      }
    },
    setCurrentOffice: (state, action) => {
      state.currentOffice = action.payload;
    },
    setOfficeAccountId: (state, action) => {
      state.officeAccountId = action.payload;
    },
    setRights: (state, action) => {
      state.rights = action.payload;
    },
    setUsers: (state, action) => {
      state.users = action.payload;
    },
  },
});

export const accountActions = slice.actions;
export const accountReducer = slice.reducer;
